// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ja-1";
export var dateTimeButtonsContainer = "_ja-6";
export var dateTimeInputContainer = "_ja-7";
export var dateTimeWrapper = "_ja-8";
export var disabledTile = "_ja-0";
export var header = "_ja-2";
export var line = "_ja-3";
export var snoozeOption = "_ja-4";
export var time = "_ja-5";
export var todayTile = "_ja-9";
export var wrapper = "_ja-a";